import React from 'react';
import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';
import { useSidebar } from '../contexts/SidebarContext';

const ToggleButton = styled.button`
  position: absolute;
  right: -16px;
  top: 55px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: white;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 1001;
  transition: all 0.2s ease;
  padding: 0;

  &:hover {
    background: #f5f5f5;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(66, 153, 225, 0.5);
  }

  .icon {
    margin: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
`;

const SidebarToggle: React.FC = () => {
  const { isOpen, toggleSidebar } = useSidebar();

  return (
    <ToggleButton
      onClick={toggleSidebar}
      aria-label={isOpen ? 'Collapse sidebar' : 'Expand sidebar'}
      data-testid="sidebar-toggle"
    >
      <Icon name={isOpen ? 'chevron left' : 'chevron right'} />
    </ToggleButton>
  );
};

export default SidebarToggle;
